import React, { useCallback, useEffect } from "react";
import { Grid, Box, Switch } from "@mui/material";
import { GridSelectionModel } from "@mui/x-data-grid";

import { GridActionsCellItem, GridRowId } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirm } from "react-confirm-box";
import Item from "../../Template/Item";
import { useDispatch, useSelector } from "react-redux";
import WithPermission from "../../components/WithPermission";
import TableSkeleton from "../../components/TableSkeleton";
import Dilogbox from "../../components/Dilogbox";
import { CustomForm } from "./info-form";
import {
  loadCustomfields,
  trashCustomfield,
  blukTrashCustomfield,
  getCustomfield,
  updateCustomfieldStatus,
} from "../../redux/actions/customfield.actions";
import { storeStateType } from "../../redux/store";
import { MultiFiltersType } from "../Worktype/Worktype";
import CustomDataGridPro from "../../components/CustomDataGridPro/CustomDataGridPro";
import CustomGridHeader from "../../components/CustomGridHeader";

// const registerSchema = object({
//   field_label: z.string().min(1, "Field label is required"),
//   field_type: z.string(),
//   required_field: z.string(),
//   field_options: z.any(),
//   status: z.any(),
//   signup_field: z.any(),
// });

// type RegisterInput = TypeOf<typeof registerSchema>;

type dataType = {
  id: string;
  field_label: string;
  field_type: string;
  required_field: string;
  field_options: string;
  field_status: any;
  signup_field: any;
};

const customOptions = {
  render: (
    message: string,
    onConfirm: React.MouseEventHandler<HTMLButtonElement>,
    onCancel: React.MouseEventHandler<HTMLButtonElement>
  ) => {
    return (
      <Dilogbox
        isDialogOpened={true}
        handleConfirmDialog={onConfirm}
        handleCloseDialog={onCancel}
        message={message}
      />
    );
  },
};

// type SearchContent = {
//   columnField: string;
//   opeartion?: string;
//   value: string;
// };

const fieldTypeList = {
  text: "TextField",
  textarea: "TextArea",
  select: "DropDown",
  file: "FileUpload",
  multiple: "Multiple",
};

export default function Customfields() {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState<number>(0);
  const [selectionModel, setSelectionModel] =
    React.useState<GridSelectionModel>([]);
  const { customfields, total, loading, current, customfield } = useSelector(
    (state: storeStateType) => state.customfield
  );
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [editRequest, setEditRequest] = React.useState<boolean>(false);
  const [trashState, setTrashState] = React.useState<boolean>(true);
  const [handelaction, setHandelaction] = React.useState("");
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [filterData, setFilterrData] = React.useState<MultiFiltersType>({
    page: 1,
    size: 10,
  });
  const [, setStateFlag] = React.useState(false);
  const [paginationEvent] = React.useState(false);
  const [csvData] = React.useState([]);
  const csvDownloadBtn = React.useRef<any>();

  const csvHeaders = [
    { label: "Field Label", key: "field_label" },
    { label: "Field Type", key: "field_type" },
    { label: "Mandatory", key: "required_field" },
  ];

  const handleOpen = async () => {
    setHandelaction(`New employeeinfo`);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (customfield && editRequest) {
      setIsOpen(true);
      setEditRequest(false);
    }
  }, [customfield, editRequest]);

  const deleteCompany = React.useCallback(
    (id: GridRowId, option: any) => async () => {
      const result = await confirm("Are you sure you want to delete?", option);
      if (result) {
        dispatch<any>(trashCustomfield(id, filterData));
        setSelectionModel([]);
        return;
      }
    },
    [dispatch, setSelectionModel, filterData]
  );

  const editCompany = React.useCallback(
    (id: GridRowId) => async () => {
      setHandelaction("Edit Info Field");
      dispatch<any>(getCustomfield(id));
      setEditRequest(true);
    },
    [dispatch]
  );

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedRow: any
  ) => {
    const formData = new FormData();
    const data: any = event.target.checked;
    formData.append("field_status", data);
    dispatch<any>(updateCustomfieldStatus(formData, clickedRow, filterData));
  };

  const handleSignUpChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedRow: any
  ) => {
    const formData = new FormData();
    const data: any = event.target.checked;
    formData.append("signup_field", data);
    dispatch<any>(updateCustomfieldStatus(formData, clickedRow, filterData));
  };

  const label = { inputProps: { "aria-label": "Switch customfield" } };

  const columns = [
    { field: "sn", headerName: "S.N.", width: 10, filterable: false },
    { field: "field_label", headerName: "Field Label", flex: 1 },
    { field: "field_type", headerName: "Field Type", width: 200 },
    { field: "required_field", headerName: "Mandatory", width: 200 },
    {
      field: "field_status",
      headerName: "Active",
      width: 100,
      filterable: false,
      renderCell: (params: any) => (
        <Switch
          {...label}
          checked={params.row.field_status}
          onChange={(e) => handleChange(e, params.row.id)}
        />
      ),
    },
    {
      field: "signup_field",
      headerName: "SignUp",
      width: 100,
      filterable: false,
      renderCell: (params: any) => (
        <Switch
          {...label}
          checked={params.row.signup_field}
          onChange={(e) => handleSignUpChange(e, params.row.id)}
        />
      ),
    },
    {
      field: "actions",
      type: "actions",
      minWidth: 20,
      flex: 0.1,
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          showInMenu
          onClick={editCompany(params.id)}
          key="action-1"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Trash"
          showInMenu
          onClick={deleteCompany(params.id, customOptions)}
          key="action-2"
        />,
      ],
    },
  ];

  const handleTrash = async (option: any) => {
    const result = await confirm("Are you sure you want to delete?", option);
    if (result) {
      const id = {
        data: {
          id: selectionModel,
        },
      };
      dispatch<any>(blukTrashCustomfield(id, filterData));
      return;
    }
  };

  useEffect(() => {
    if (paginationEvent) {
      setFilterrData((prev) => ({ ...prev, page: page + 1 }));
      setStateFlag((preState) => !preState);
    }
  }, [page, paginationEvent, setFilterrData, setStateFlag]);

  useEffect(() => {
    if (csvData.length) {
      csvDownloadBtn.current.link.click();
    }
  }, [csvData]);

  let rows =
    Array.isArray(customfields) && customfields?.length >= 0
      ? customfields.map((obj: dataType, index: number) => {
          let _id = current === 1 ? 1 : pageSize * (current - 1) + 1;
          const key = obj.field_type;
          let str = key as keyof typeof fieldTypeList;
          return {
            id: obj.id,
            sn: index + _id,
            field_label: obj.field_label,
            field_type: fieldTypeList[str],
            required_field: obj.required_field === "1" ? "Yes" : "No",
            field_status: obj.field_status,
            signup_field: obj.signup_field,
          };
        })
      : [];

  useEffect(() => {
    dispatch<any>(loadCustomfields(filterData));
  }, [filterData, dispatch]);

  const handleCloseCustomForm = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <WithPermission
          roleReqiured={["ADMIN", "EMPLOYEE", "STAFF", "USER"]}
          message="Access Denied"
        >
          <Item>
            <CustomGridHeader
              title={`employeeinfo`}
              handleAddClick={handleOpen}
              handleBulkDelete={() => handleTrash(customOptions)}
              disabledTrashState={trashState}
            />

            {/* <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
          >
            <Typography variant="h6" fontSize={"1.67rem"} gutterBottom m={1}>
              {`${menus["employeeinfo"] ?? ""}`}
            </Typography>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Button
                variant="contained"
                onClick={() => handleOpen()}
                startIcon={<AddIcon />}
                sx={{ mr: 1 }}
              >
                {`${menus["employeeinfo"] ?? ""}`}
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleTrash(customOptions)}
                disabled={trashState}
                startIcon={<DeleteIcon />}
              >
                Trash
              </Button>
            </Box>
          </Stack> */}
            <Box sx={{ height: 700, width: "100%" }}>
              {rows ? (
                // <DataGridPro
                //   loading={loading}
                //   columns={columns}
                //   rows={rows}
                //   pagination
                //   checkboxSelection
                //   disableRowSelectionOnClick
                //   rowCount={total}
                //   pageSizeOptions={[5, 10, 100]}
                //   paginationMode="server"
                //   rowSelectionModel={selectionModel}
                //   onRowSelectionModelChange={(newSelectionModel) => {
                //     newSelectionModel.length
                //       ? setTrashState(false)
                //       : setTrashState(true);
                //     setSelectionModel(newSelectionModel);
                //   }}
                //   //keepNonExistentRowsSelected
                //   initialState={{
                //     pagination: {
                //       paginationModel: {
                //         pageSize: pageSize,
                //         page: page,
                //       },
                //     },
                //   }}
                //   components={{
                //     Toolbar: CustomToolbar,
                //     LoadingOverlay: LinearProgress,
                //   }}
                //   componentsProps={{
                //     toolbar: {
                //       showQuickFilter: true,
                //       quickFilterProps: { debounceMs: 500 },
                //     },
                //   }}
                //   filterMode="server"
                //   onFilterModelChange={onFilterChange}
                //   onPaginationModelChange={handlePageChange}
                // />
                <CustomDataGridPro
                  totalRows={total}
                  loading={loading}
                  columns={columns}
                  rows={rows}
                  setFilterData={setFilterrData}
                  csvHeaders={csvHeaders}
                  currentPage={page}
                  pageLimit={pageSize}
                  setCurrentPage={setPage}
                  setPageLimit={setPageSize}
                  exportCSVUrl="/employeeinfo/csv"
                  filterData={filterData}
                  disableRowSelectionOnClick={true}
                  defaultCSVExport={false}
                  handleRowSelectionModelChange={(
                    newSelectionModel: React.SetStateAction<GridSelectionModel>
                  ) => {
                    newSelectionModel.length
                      ? setTrashState(false)
                      : setTrashState(true);
                    setSelectionModel(newSelectionModel);
                  }}
                  csvFilename={`EmployeeInfo`}
                />
              ) : (
                <TableSkeleton />
              )}
            </Box>
          </Item>
        </WithPermission>
      </Grid>
      <CustomForm
        // titleName={menus["employeeinfo"] ?? ""}
        isDialogOpened={isOpen}
        handleCloseDialog={handleCloseCustomForm}
        action={handelaction}
        filterData={filterData}
      />
    </Grid>
  );
}
